
import { defineComponent, PropType } from "vue";

import { NDatePicker, NFormItem } from "naive-ui";

import { useModelValue } from "@/composables/use-model-value";

import { Attribute } from "@/models/tile.model";

export default defineComponent({
  name: "DatePickerElement",

  props: {
    modelValue: String,

    attribute: {
      type: Object as PropType<Attribute>,
      required: true,
    },
  },

  components: {
    NDatePicker,
    NFormItem,
  },

  setup(props, context) {
    const localValue = useModelValue(props, context.emit);

    return {
      localValue,

      preventKeyboard(event: Event) {
        event.preventDefault();
      },
    };
  },
});
